import { apiGet } from "../../api/apiClient";

const BASE = "/api/admin/monitoring";

export const fetchEmployeeMonitoring = (date) =>
  apiGet(`${BASE}/employees?dateFilter=${date}`);

export const fetchEmployeeCandidates = (employeeId, date) =>
  apiGet(`${BASE}/employees/${employeeId}/candidates?dateFilter=${date}`);
